import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import LoadingIcon from '../shared/LoadingIcon';
import i18n from '../../config/i18n';

const styles = {
  thead: {
    backgroundColor: '#607484', color: '#FFF',
  },
};

class FileList extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
    fileList: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      filename: PropTypes.string,
      type: PropTypes.string,
      modifiedAt: PropTypes.string,
    })),
    isLoading: PropTypes.bool,
    viewOnly: PropTypes.bool,
  };

  static defaultProps = {
    fileList: [],
    isLoading: false,
    viewOnly: false,
  };

  prepareHaveFilesHtml = (
    {
      id,
      filename,
      type,
      modifiedAt,
    },
    index,
    viewOnly,
  ) => (
    <tr key={id}>
      <td>{index + 1}</td>
      <td>{filename}</td>
      <td>{type}</td>
      <td>{moment(modifiedAt).format('YYYY-MM-DD hh:mm:ss A')}</td>
      <td>
        {
          viewOnly
            ? null
            : (
              <button
                className="btn btn-sm btn-info"
                onClick={() => this.handleDownloadButtonClick(id)}
              >
                {i18n.t('download')}
              </button>
            )}
      </td>
      <td>
        {
          viewOnly
            ? null
            : (
              <button
                className="btn btn-sm btn-danger"
                onClick={() => this.handleDeleteButtonClick(id)}
              >
                {i18n.t('delete')}
              </button>
            )}
      </td>
    </tr >
  );

  prepareLoadingHtml = () => (
    <tr>
      <td><LoadingIcon /></td>
      <td />
      <td />
      <td />
      <td />
      <td />
    </tr>
  );

  prepareNoFilesHtml = () => (
    <tr>
      <td>{i18n.t('noFilesFound')}</td>
      <td />
      <td />
      <td />
      <td />
      <td />
    </tr>
  );

  prepareFileListHtml = () => {
    const {
      isLoading,
      fileList,
      viewOnly,
    } = this.props;

    if (isLoading) {
      return this.prepareLoadingHtml();
    }
    if (!fileList.length) {
      return this.prepareNoFilesHtml();
    }
    return fileList.map((file, index) => this.prepareHaveFilesHtml(file, index, viewOnly));
  };

  handleDownloadButtonClick = (id) => {
    const { onDownloadButtonClick } = this.props;
    onDownloadButtonClick(id);
  };

  handleDeleteButtonClick = (id) => {
    const { onDeleteButtonClick } = this.props;
    onDeleteButtonClick(id);
  };

  render() {
    const fileList = this.prepareFileListHtml();
    return (
      <table className="table table-striped table-hover table-responsive PatientList">
        <thead style={styles.thead}>
          <tr>
            <th>#</th>
            <th>{i18n.t('fileName')}</th>
            <th>{i18n.t('format')}</th>
            <th>{i18n.t('created')}</th>
            <th>{i18n.t('download')}</th>
            <th>{i18n.t('delete')}</th>
          </tr>
        </thead>
        <tbody>
          {fileList}
        </tbody>
      </table>
    );
  }
}

export default FileList;



// WEBPACK FOOTER //
// ./src/components/file/FileList.js